import React from 'react'
import { Shield, Lock, Globe } from 'lucide-react'

export const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Privacy Info */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-2 mb-3">
              <Shield className="w-5 h-5 text-netflix-red" />
              <h3 className="text-lg font-semibold text-white">Private & Secure</h3>
            </div>
            <p className="text-sm text-gray-400">
              Your family videos are protected with enterprise-level security. 
              Invite-only access ensures complete privacy.
            </p>
          </div>

          {/* Features */}
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 mb-3">
              <Lock className="w-5 h-5 text-netflix-red" />
              <h3 className="text-lg font-semibold text-white">Encrypted Storage</h3>
            </div>
            <p className="text-sm text-gray-400">
              All videos secured with enterprise-grade storage. 
              Time-expiring tokens protect against unauthorized access.
            </p>
          </div>

          {/* Domain Info */}
          <div className="text-center md:text-right">
            <div className="flex items-center justify-center md:justify-end space-x-2 mb-3">
              <Globe className="w-5 h-5 text-netflix-red" />
              <h3 className="text-lg font-semibold text-white">Powered by Cloudflare</h3>
            </div>
            <p className="text-sm text-gray-400">
              Global CDN delivery with Cloudflare R2. 
              Premium security and performance for your memories.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-sm text-gray-500">
                © 2024 VideoShareWEB • Private Family Video Platform
              </p>
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-500">
              <span>waltsportal.com</span>
              <span>•</span>
              <span>Invite-Only Access</span>
              <span>•</span>
              <span>Family Videos</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}